import React from 'react';
import ReviewerContent from 'components/admin/reviewer/ReviewerContent';

export const ReviewerPage: React.FC = () => {
  return <ReviewerContent />;
};
